export function thumbnailImagePath(image: string): string {
  return "/image/thumbnail/" + image;
}

export function scaledImagePath(image: string): string {
  return "/image/scaled/" + image;
}

export function nameToId(name: string): string {
  return name.toLowerCase().replace(/ /g, "_");
}